import React from 'react';
import { Helmet } from 'react-helmet-async';

const Orders = () => {
  return (
    <>
      <Helmet>
        <title>Pedidos - Cerveja Delivery</title>
      </Helmet>
      <div className="space-y-6">
        <h2 className="text-2xl font-bold text-dark-900">Gerenciar Pedidos</h2>
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <div className="text-center text-dark-500">
            Nenhum pedido recebido hoje.
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;